import { Alert, Box, Button, Paper, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

const Unsubscribe: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [error, setError] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  // forwardedError can be 'true', 'false', or null
  const [hasParams, setHasParams] = useState(false);

  useEffect(() => {
    // On first mount, check for params
    if ([...searchParams].length === 0) {
      navigate('/', { replace: true });
      return;
    }
    setHasParams(true);

    const err = searchParams.get('err');
    setError(err === 'true');

    // Strip search params from URL after processing
    setSearchParams({});
    // Only run this logic once
    // eslint-disable-next-line
  }, []);

  // Only render if we had params on first mount
  if (!hasParams) return null;

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, p: 2 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
          border: `1px solid ${theme.palette.divider}`,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          {error && (
            <Alert
              severity="error"
              sx={{
                borderRadius: 2,
                mb: 2,
              }}
            >
              Unsubscribe failed
            </Alert>
          )}
          {!error && (
            <Alert
              severity="success"
              sx={{
                borderRadius: 2,
                mb: 2,
              }}
            >
              You have been unsubscribed from email notifications
            </Alert>
          )}
        </Box>
      </Paper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '20px',
          textAlign: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <Button sx={{ textTransform: 'none' }}>
          <Link to="/">Home</Link>
        </Button>
        <Button sx={{ textTransform: 'none' }}>
          <Link to="/notification">Email Notifications</Link>
        </Button>
      </Box>
    </Box>
  );
};

export default Unsubscribe;
